// Mock data for Velox Hint website

export const getServicesData = (language = 'RU') => {
  const services = {
    RU: [
      // Нетарифное регулирование
      {
        id: 1,
        title: "Нотификация ФСБ РФ",
        description: "Наши специалисты по криптографии правильно определят алгоритмы и протоколы в ваших шифровальных средствах",
        timeframe: "1-2 дня",
        category: "nonTariff",
        slug: "fsb-notification"
      },
      {
        id: 2,
        title: "Нотификация СНБ Армении",
        description: "Уведомление службы национальной безопасности Армении о ввозе шифровальных средств",
        timeframe: "3-5 дней",
        category: "nonTariff",
        slug: "armenia-snb-notification"
      },
      {
        id: 3,
        title: "Лицензия Минпромторга",
        description: "Составим макеты всех документов и быстро получим лицензию Минпромторга",
        timeframe: "1-2 дня",
        category: "nonTariff",
        slug: "minpromtorg-license"
      },
      {
        id: 4,
        title: "Разрешение Роскомнадзора на временный ввоз",
        description: "Для временного ввоза радиоэлектронных средств и высокочастотных устройств",
        timeframe: "до 10 дней",
        category: "nonTariff",
        slug: "roskomnadzor-temporary-permit"
      },
      {
        id: 5,
        title: "Выписка из реестра Роскомнадзора",
        description: "Для временного ввоза радиоэлектронных средств и высокочастотных устройств",
        timeframe: "до 10 дней",
        category: "nonTariff",
        slug: "roskomnadzor-registry-excerpt"
      },
      {
        id: 6,
        title: "Заключение ГРЧЦ",
        description: "Проверим радиочастотные характеристики на соответствие российским нормам и оформим заключение",
        timeframe: "1-2 дня",
        category: "nonTariff",
        slug: "grfc-conclusion"
      },
      {
        id: 7,
        title: "Идентификационное заключение ФСТЭК",
        description: "Идентификационное заключение о неотнесении продукции к контрольным спискам",
        timeframe: "4-6 дней",
        category: "nonTariff",
        slug: "fstec-identification"
      },
      {
        id: 8,
        title: "Лицензия ФСТЭК",
        description: "Лицензия на осуществление деятельности по технической защите конфиденциальной информации",
        timeframe: "30-45 дней",
        category: "nonTariff",
        slug: "fstec-license"
      },
      {
        id: 9,
        title: "Заключение ФСВТС",
        description: "Заключение о возможности поставки продукции на экспорт",
        timeframe: "15-30 дней",
        category: "nonTariff",
        slug: "fsvts-conclusion"
      },
      {
        id: 10,
        title: "Разрешение МВД",
        description: "Для ввоза прекурсоров наркотических средств и психотропных веществ",
        timeframe: "15-20 дней",
        category: "nonTariff",
        slug: "mvd-permit"
      },

      // Товарный знак
      {
        id: 11,
        title: "Регистрация товарного знака",
        description: "Полное сопровождение процедуры регистрации товарного знака в Роспатенте",
        timeframe: "12-18 месяцев",
        category: "trademark",
        slug: "trademark-registration"
      },
      {
        id: 12,
        title: "Поиск по товарным знакам",
        description: "Проверка на схожесть с уже зарегистрированными товарными знаками",
        timeframe: "3-5 дней",
        category: "trademark",
        slug: "trademark-search"
      },
      {
        id: 13,
        title: "Продление товарного знака",
        description: "Продление срока действия регистрации товарного знака",
        timeframe: "2-4 месяца",
        category: "trademark",
        slug: "trademark-renewal"
      },

      // Маркировка и ЧЗ
      {
        id: 14,
        title: "Обучение ведению маркировки",
        description: "Комплексное обучение сотрудников работе с системой маркировки товаров",
        timeframe: "1-3 дня",
        category: "marking",
        slug: "marking-training"
      },
      {
        id: 15,
        title: "Полное ведение",
        description: "Полное ведение процессов маркировки товаров от А до Я",
        timeframe: "постоянно",
        category: "marking",
        slug: "full-marking-management"
      },
      {
        id: 16,
        title: "Помощь в создании маркировки",
        description: "Консультационная поддержка при создании системы маркировки",
        timeframe: "5-10 дней",
        category: "marking",
        slug: "marking-creation-help"
      }
    ],
    EN: [
      // Non-tariff Regulation
      {
        id: 1,
        title: "FSB RF Notification",
        description: "Our cryptography specialists will correctly identify algorithms and protocols in your encryption tools",
        timeframe: "1-2 days",
        category: "nonTariff",
        slug: "fsb-notification"
      },
      {
        id: 2,
        title: "Armenia SNB Notification",
        description: "Notification to Armenia's National Security Service about importing encryption tools",
        timeframe: "3-5 days",
        category: "nonTariff",
        slug: "armenia-snb-notification"
      },
      {
        id: 3,
        title: "Minpromtorg License",
        description: "We will prepare document templates and quickly obtain a Minpromtorg license",
        timeframe: "1-2 days",
        category: "nonTariff",
        slug: "minpromtorg-license"
      },
      {
        id: 4,
        title: "Roskomnadzor Temporary Import Permit",
        description: "For temporary import of radio-electronic equipment and high-frequency devices",
        timeframe: "up to 10 days",
        category: "nonTariff",
        slug: "roskomnadzor-temporary-permit"
      },
      {
        id: 5,
        title: "Roskomnadzor Registry Extract",
        description: "For temporary import of radio-electronic equipment and high-frequency devices",
        timeframe: "up to 10 days",
        category: "nonTariff",
        slug: "roskomnadzor-registry-excerpt"
      },
      {
        id: 6,
        title: "GRFC Conclusion",
        description: "We will check radio frequency characteristics for compliance with Russian standards and issue a conclusion",
        timeframe: "1-2 days",
        category: "nonTariff",
        slug: "grfc-conclusion"
      },
      {
        id: 7,
        title: "FSTEC Identification Conclusion",
        description: "Identification conclusion on non-attribution of products to control lists",
        timeframe: "4-6 days",
        category: "nonTariff",
        slug: "fstec-identification"
      },
      {
        id: 8,
        title: "FSTEC License",
        description: "License for activities in technical protection of confidential information",
        timeframe: "30-45 days",
        category: "nonTariff",
        slug: "fstec-license"
      },
      {
        id: 9,
        title: "FSVTS Conclusion",
        description: "Conclusion on the possibility of product export",
        timeframe: "15-30 days",
        category: "nonTariff",
        slug: "fsvts-conclusion"
      },
      {
        id: 10,
        title: "MVD Permit",
        description: "For importing precursors of narcotic drugs and psychotropic substances",
        timeframe: "15-20 days",
        category: "nonTariff",
        slug: "mvd-permit"
      },

      // Trademark
      {
        id: 11,
        title: "Trademark Registration",
        description: "Full support of trademark registration procedure with Rospatent",
        timeframe: "12-18 months",
        category: "trademark",
        slug: "trademark-registration"
      },
      {
        id: 12,
        title: "Trademark Search",
        description: "Checking for similarity with already registered trademarks",
        timeframe: "3-5 days",
        category: "trademark",
        slug: "trademark-search"
      },
      {
        id: 13,
        title: "Trademark Renewal",
        description: "Extension of trademark registration validity period",
        timeframe: "2-4 months",
        category: "trademark",
        slug: "trademark-renewal"
      },

      // Marking & CZ
      {
        id: 14,
        title: "Marking Management Training",
        description: "Comprehensive training for employees in working with product marking systems",
        timeframe: "1-3 days",
        category: "marking",
        slug: "marking-training"
      },
      {
        id: 15,
        title: "Full Management",
        description: "Complete management of product marking processes from A to Z",
        timeframe: "ongoing",
        category: "marking",
        slug: "full-marking-management"
      },
      {
        id: 16,
        title: "Marking Creation Assistance",
        description: "Consulting support in creating a marking system",
        timeframe: "5-10 days",
        category: "marking",
        slug: "marking-creation-help"
      }
    ]
  };
  
  return services[language] || services.RU;
};

export const servicesData = getServicesData('RU'); // Default to Russian

export const processSteps = [
  {
    number: "01",
    title: "Направьте нам техническое описание товара",
    description: "Пришлите документы для анализа"
  },
  {
    number: "02", 
    title: "Получите коммерческое предложение",
    description: "В течение одного рабочего дня"
  },
  {
    number: "03",
    title: "Подпишите договор и оплатите услугу",
    description: "Простое оформление документов"
  },
  {
    number: "04",
    title: "Получите макеты документов на проверку",
    description: "Подпишите их согласно инструкциям"
  }
];

export const advantages = [
  {
    title: "Бесплатная экспертиза",
    description: "Технический анализ в день обращения",
    icon: "FileText"
  },
  {
    title: "Высокая скорость",
    description: "Подготовка документов за 1 рабочий день",
    icon: "Clock"
  },
  {
    title: "Индивидуальный подход",
    description: "Персональный менеджер для каждого клиента",
    icon: "User"
  },
  {
    title: "Высокая квалификация",
    description: "Экспертность в таможенном законодательстве",
    icon: "Award"
  },
  {
    title: "Надежное партнерство", 
    description: "Долгосрочные доверительные отношения",
    icon: "Handshake"
  },
  {
    title: "Штат экспертов",
    description: "Лучшие специалисты в области",
    icon: "Users"
  }
];

export const partners = [
  { name: "DHL", description: "Немецкая логистическая компания" },
  { name: "Samsung", description: "Производитель электроники" },
  { name: "LG", description: "Производитель электроники" },
  { name: "Volkswagen", description: "Автомобильный концерн" },
  { name: "Siemens", description: "Производитель техники" },
  { name: "Яндекс", description: "Интернет-портал" }
];

export const governmentAgencies = [
  "Минпромторг России",
  "Федеральная служба безопасности", 
  "ФСТЭК России",
  "Роскомнадзор",
  "Министерство внутренних дел",
  "Главный радиочастотный центр"
];